import { isKPIChartEnhancementsEnabled } from '@thoughtspot/session-service';
import cx from 'classnames';
import React, { useCallback, useLayoutEffect } from 'react';
import styles from '../../../styles/kpi.module.scss';
import { Analyze } from './analyze';
import { CCAErrorModal } from './cca-error-modal';
import { TEST_IDS } from './constants';
import { SimpleKPIContent } from './simple-kpi-content';
import { useChangeAnalysis } from './use-change-analysis';
import { useKpiModel } from './use-kpi-model';
import { callPerfLog } from '../../../utils/perf-utils';
export const SimpleKPIChart = React.forwardRef((props, _ref) => {
    var _a, _b;
    const { chartModel, env, config, chartObj, dataModel, eventsMap, onRenderComplete } = props;
    const model = useKpiModel(chartModel);
    const analyzeButton = useChangeAnalysis(model, {
        chartModel,
        env,
        config,
        chartObj,
        dataModel,
        eventsMap,
    });
    const isKpiStyleEnhancementEnabled = isKPIChartEnhancementsEnabled();
    const showKpiInCenter = (_a = env === null || env === void 0 ? void 0 : env.flags) === null || _a === void 0 ? void 0 : _a.isCenterSingleValueKPIEnabled;
    const isPresentModeOn = (_b = chartObj === null || chartObj === void 0 ? void 0 : chartObj.chartOptions) === null || _b === void 0 ? void 0 : _b.shouldScaleFonts;
    useLayoutEffect(() => {
        callPerfLog('TEXT_RENDER_COMPLETE', 'COMPLETE', { trackingId: chartModel.id });
        onRenderComplete === null || onRenderComplete === void 0 ? void 0 : onRenderComplete();
    }, [chartModel.id, onRenderComplete]);
    const handleCloseModal = useCallback(() => analyzeButton.setIsCCAErrorModalOpen(false), [analyzeButton.setIsCCAErrorModalOpen]);
    return (React.createElement("div", { className: cx(styles.kpi, {
            [styles.centerKpi]: showKpiInCenter,
            [styles.kpiNoFlexWrap]: isKpiStyleEnhancementEnabled,
        }), "data-testid": TEST_IDS.KPI },
        React.createElement(SimpleKPIContent, { ...props, model: model, onChangeAnalysisClick: analyzeButton.onChangeAnalysisClick, handleKeyPress: analyzeButton.handleKeyPress, tooltip: analyzeButton.tooltip, isEmptyComparison: analyzeButton.isEmptyComparison, isAnomalyV2Enabled: analyzeButton.isAnomalyV2Enabled }),
        analyzeButton.showAnalyzeButton && !analyzeButton.isPrintMode ? (React.createElement(Analyze, { tooltip: analyzeButton.tooltip, onChangeAnalysisClick: analyzeButton.onChangeAnalysisClick, isAnalyzeButtonEnabled: analyzeButton.isAnalyzeButtonEnabled, isPresentModeOn: isPresentModeOn, handleKeyPress: analyzeButton.handleKeyPress, shouldApplyMargin: false, isEmptyComparison: analyzeButton.isEmptyComparison, setIsCCAErrorModalOpen: analyzeButton.setIsCCAErrorModalOpen })) : null,
        React.createElement(CCAErrorModal, { isOpen: analyzeButton.isCCAErrorModalOpen, onClose: handleCloseModal })));
});
//# sourceMappingURL=simple-kpi-chart.js.map